import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

/**
 * Scroll the window back to the top whenever the page (the path) changes.
 *
 * The window is what scrolls in Comms V2, so without this a page opened
 * from the bottom of a long list started scrolled down. A change of query
 * or hash alone (a filter, a tab) keeps the position. Renders nothing.
 */
const ScrollToTop = () => {
    const { pathname } = useLocation()
    useEffect(() => {
        window.scrollTo(0, 0)
    }, [pathname])
    return null
}

export default ScrollToTop
